module.exports = __webpack_public_path__ + "img/icon_bonus.136099e4.svg";